import { darken, useTheme } from '@mui/material';
import { Animations, ChartData, ChartOptions } from 'chart.js';
import { FC, useMemo } from 'react';
import { Line } from 'react-chartjs-2';

export type ItemDataset = { key: 'string' };

const options: ChartOptions<'line'> = {
  elements: {
    line: {
      tension: 0.3,
    },
  },
  responsive: true,
  animation: Animations[0],
  maintainAspectRatio: false,
  scales: {
    x: {
      type: 'time',
      time: {
        unit: 'day',
      },
      grid: {
        display: false,
      },
    },
    y: {
      min: 0,
      stacked: true,
      grid: {
        display: true,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: item =>
          `${item.formattedValue} ${
            (item.dataset as unknown as ItemDataset).key
          } issues`,
      },
    },
  },
};

const IssuesGraph: FC<React.PropsWithChildren<IssuesGraphProps>> = ({
  labels,
  data,
  height,
}) => {
  const theme = useTheme();
  const colors = theme.palette.categoryRiskColor;
  const dataset = useMemo(
    (): ChartData<'line', number[], number> => ({
      labels,
      datasets: Object.keys(data).map(key => ({
        key,
        data: data[key],
        fill: true,
        backgroundColor: colors[key],
        borderColor: colors[key],
        pointBackgroundColor: darken(colors[key], 0.1),
        pointBorderColor: darken(colors[key], 0.1),
      })),
    }),
    [labels, data, colors],
  );

  return <Line data={dataset} options={options} height={height || '100px'} />;
};

export interface IssuesGraphProps {
  labels: number[];
  data: { [key: string]: number[] };
  height?: string;
}

export default IssuesGraph;
